import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import {
  getPackageFeatures,
  getPackageOffers,
  getPackagePlanDetails,
} from "src/pages/api/pricing";
import { PricingPackageProps } from "./Package.types";

function PricingPackage(Props: PricingPackageProps): JSX.Element {
  const {
    id,
    name,
    summary,
    numberOfUsers,
    cost,
    period,
    setDisplayPlan,
    showButton = true,
    variant = "potrait",
  } = Props;
  const [offers, setOffers] = useState([]);
  const [featuresSupported, setFeaturesSupported] = useState([]);
  const [packagePlanDetails, setPackagePlanDetails] = useState([]);
  const router = useRouter();

  useEffect(() => {
    getPackageOffers(id).then((response) => {
      setOffers(response.data.data[0]);
    });
    getPackageFeatures(id).then((response) => {
      setFeaturesSupported(response.data.data[0]);
    });
    getPackagePlanDetails(id).then((response: any) => {
      setPackagePlanDetails(response.data.data[0]);
    });
  }, [period]);

  return (
    <div className="w-full pb-8" id={`package${name}`}>
      {variant === "landscape" ? (
        <div className="w-full rounded-lg shadow-md border h-auto  ">
          <div className="px-6 py-10 flex gap-x-4 justify-between">
            <div className="space-y-6">
              <div className="w-full flex text-[#262626]">
                <img
                  src="/icons/Other-03.svg"
                  className="w-10 h-10"
                  alt="other"
                />
                <span
                  className={` phone:text-[24px] leading-[120%] text-3xl text-black font-medium ml-4`}
                >
                  {name}
                </span>
              </div>
              <div
                className={` w-full text-[#7B7B7B] leading-[150%] text-black500 text-base phone:text-[16px] mt-4`}
              >
                {summary}
              </div>
              <div className="flex justify-between">
                <div className="w-1/4 py-1 px-3 text-base text-center rounded-xl bg-[#EEE7F8] text-blue500">
                  {numberOfUsers > 998 ? "Unlimited" : numberOfUsers} Users
                </div>
                <div className="w-1/4 font-bold text-3xl text-blue500">
                  <span className="">
                    £{cost}
                    <span className="text-sm">
                      /
                      {period === "monthly"
                        ? "month"
                        : period === "yearly"
                        ? "year"
                        : ""}
                    </span>
                  </span>
                </div>
              </div>

              <div className="border " />
              <div className="w-full mt-8 flex font-bold flex-col gap-y-4 phone:mb-14 phone:pb-[24px]  text-base">
                {offers.map((offer: any) => (
                  <div>
                    <div className="w-full flex">
                      <img
                        src="/icons/Small.svg"
                        width={22}
                        height={22}
                        alt=""
                      />
                      <span className=" ml-2 leading-[150%]">{offer.name}</span>
                    </div>
                    <div>
                      {offer.name.includes("eatures") ? (
                        <div className="ml-6 space-y-2">
                          {featuresSupported.map((feature: any) => (
                            <div className="w-full flex ml-4">
                              <div
                                className={`${
                                  name.toLowerCase() !== "basic plan"
                                    ? "bg-black"
                                    : "bg-white"
                                } self-center rounded-full w-1 h-1`}
                              />
                              <div className="self-center ml-2 font-normal leading-[150%]">
                                {feature.name}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-1/2 rounded-lg ">
              <div className="p-3 border h-full rounded-xl space-y-4  text-sm bg-[#EDEEFC]">
                <div>Plan Details:</div>
                <div className="space-y-3">
                  {packagePlanDetails.map((planDetails: any) => (
                    <div className="font-bold flex gap-x-2">
                      <div className="mt-2">
                        <div className={`bg-black w-1 h-1  rounded-full`} />
                      </div>
                      <div className="">
                        <span>{planDetails.heading}: </span>
                        <span className="font-normal">{planDetails.body}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full h-auto flex justify-between gap-x-10 gap-y-0 phone:gap-y-10 phone:flex-col ">
          <div
            className={
              name.toLocaleLowerCase() === "basic plan"
                ? "w-full phone:w-full h-full rounded-3xl relative flex flex-col p-6 phone:pb-0 border bg-blue500 text-white"
                : "w-full phone:w-full h-full rounded-3xl relative flex flex-col p-6 phone:pb-0 border bg-white"
            }
          >
            <div className="w-full space-y-6 pb-8 h-full relative ">
              <div className="w-full flex text-[#262626]">
                <img src="/icons/Other-03.svg" className="w-10 h-10" alt="" />
                <span
                  className={`${
                    name.toLowerCase() === "basic plan" ? "text-white " : ""
                  } phone:text-[24px] leading-[120%] text-[30px] font-medium ml-4`}
                >
                  {name}
                </span>
              </div>
              <div className="w-full py-4">
                {showButton ? (
                  <div
                    role="button"
                    tabIndex={0}
                    onKeyDown={() => {}}
                    onClick={() => {
                      if (setDisplayPlan) {
                        setDisplayPlan(false);
                      } else {
                        localStorage.setItem("selectedPackage", id.toString());
                        localStorage.setItem(
                          "selectedPackagePeriod",
                          period.toString()
                        );
                        localStorage.setItem(
                          "selectedPackageCost",
                          cost.toString()
                        );
                        localStorage.setItem(
                          "selectedPackageName",
                          name.toString()
                        );
                        localStorage.setItem(
                          "selectedPackageSummary",
                          summary.toString()
                        );
                        router.push({
                          pathname: "/subscription/account-information",
                          query: {
                            selectedPackage: id,
                          },
                        });
                      }
                    }}
                    className={
                      name.toLocaleLowerCase() === "basic plan"
                        ? "bg-white text-blue500 py-4 text-center rounded-2xl border border-blue500"
                        : "bg-blue500 text-white py-4 text-center rounded-2xl border border-blue500"
                    }
                  >
                    Get Started
                  </div>
                ) : null}
              </div>
              <div
                className={`${
                  name.toLowerCase() === "basic plan" ? "text-white " : ""
                } w-full text-[#7B7B7B] leading-[150%] text-base mt-4`}
              >
                {summary}
              </div>

              <div className="w-full mt-[16px] mb-[24px] text-[#4856DD] leading-[120%] text-[48px] phone:text-[32px] font-bold ">
                <span
                  className={
                    name.toLowerCase() === "basic plan" ? "text-white" : ""
                  }
                >
                  £{cost}/
                  {period === "monthly"
                    ? "month"
                    : period === "yearly"
                    ? "year"
                    : ""}
                </span>
              </div>
              <div className="border " />
              <div className="">
                <div className="w-2/4 py-1 px-3 text-base text-center rounded-xl bg-[#EEE7F8] text-blue500">
                  {numberOfUsers > 998 ? "Unlimited" : numberOfUsers} Users
                </div>
              </div>
              <div className="w-full mt-8 flex font-bold flex-col gap-y-4 phone:mb-14 phone:pb-[24px]  text-base phone:text-[14px]">
                {offers.map((offer: any) => (
                  <div>
                    <div className="w-full flex">
                      <img
                        src="/icons/Small.svg"
                        width={22}
                        height={22}
                        alt=""
                      />
                      <span className=" ml-2 leading-[150%]">{offer.name}</span>
                    </div>
                    <div>
                      {offer.name.includes("eatures") ? (
                        <div className="ml-6 space-y-2">
                          {featuresSupported.map((feature: any) => (
                            <div className="w-full flex ml-4">
                              <div
                                className={`${
                                  name.toLowerCase() !== "basic plan"
                                    ? "bg-black"
                                    : "bg-white"
                                } self-center rounded-full w-1 h-1`}
                              />
                              <div className="self-center ml-2 font-normal leading-[150%]">
                                {feature.name}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>

              <div
                className={`p-3 rounded-xl space-y-4  text-sm ${
                  name.toLocaleLowerCase() === "basic plan"
                    ? "bg-[#0000D8] "
                    : "bg-[rgba(237,238,252,0.4)]"
                }  `}
              >
                <div>Plan Details:</div>
                <div className="space-y-3">
                  {packagePlanDetails.map((planDetails: any) => (
                    <div className="font-bold flex gap-x-2">
                      <div className="mt-2">
                        <div
                          className={`${
                            name.toLowerCase() === "basic plan"
                              ? "bg-white"
                              : "bg-black"
                          } w-1 h-1  rounded-full`}
                        />
                      </div>
                      <div className="">
                        <span>{planDetails.heading}: </span>
                        <span className="font-normal">{planDetails.body}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PricingPackage;
